// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LaborAdditiveSummary from '@deere/cps-it.warranty-model-factory/lib/labor-additive-summary';
import {buildClassName} from '../../../shared/services/build-class-name';
import {buildNumber} from '../../../../shared/services/build-number';

const LaborAdditiveSummaryItemForModal = props =>
    <div className='labor-additive-summary-item-for-modal'>
        <div className='labor-additive-summary-status'>
            <div className='label'>
                <FormattedMessage id='GROUP_COMPLETE'/>
            </div>
            <div className='percentage'>
                {`${buildNumber(props.laborAdditiveSummary.completePercentage)}%`}
            </div>
            <div className='status-indicator'>
                <span className={buildClassName(props.laborAdditiveSummary.targetCompletion, props.laborAdditiveSummary.completePercentage)}/>
            </div>
        </div>
        <div className='labor-additive-summary-details'>
            <div className='labor-additive-summary-group'>
                {props.laborAdditiveSummary.group}
            </div>
        </div>
    </div>;

LaborAdditiveSummaryItemForModal.displayName = 'LaborAdditiveSummaryItemForModal';
LaborAdditiveSummaryItemForModal.propTypes = {
    laborAdditiveSummary: PropTypes.instanceOf(LaborAdditiveSummary).isRequired
};

export default LaborAdditiveSummaryItemForModal;



// WEBPACK FOOTER //
// ./src/pip/labor-additive/components/labor-additive-summary/labor-additive-summary-item-for-modal.js